import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from 'packages/ui/Button';
import FontIcon from 'packages/ui/FontIcon';
import variables from 'packages/ui/variables';

const ButtonLikeWrapper = styled.div`
  border: 2px solid #3ba2de;
  padding: 8px;
  box-sizing: border-box;
  min-width: 100px;
  display: block;
  text-align: center;
  background: white;
  margin: 4px;

  > a {
    width: 100%;
    display: block;
  }
`;

const IconButtonWrapper = styled(Button)`
  padding: 0;

  div.icon-wrapper {
    border: 1px solid ${props => variables.color[props.mood]};
    padding: 4px;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
  }
`;

function ButtonLikeLink({ url, text, target = '_blank', internal = false }) {
  return (
    <ButtonLikeWrapper>
      {internal ? (
        <Link to={url}>{text}</Link>
      ) : (
        <a href={url} target={target} rel="noopener noreferrer">
          {text}
        </a>
      )}
    </ButtonLikeWrapper>
  );
}

function IconButton({ iconName, fontSize, handleClick, mood }) {
  return (
    <IconButtonWrapper
      glass
      size="small"
      mood={mood}
      onClick={handleClick}
      disabled={mood === 'disabled' ? true : false}
    >
      <div className="icon-wrapper">
        <FontIcon name={iconName} size={fontSize} />
      </div>
    </IconButtonWrapper>
  );
}

export { ButtonLikeLink, IconButton };
